import Layout from "@/components/Layout";
import { Link } from "react-router-dom";

export default function ForStudents() {
  return (
    <Layout>
      <section className="container-msis py-16">
        <div className="overline mb-3">For Students</div>
        <h1 className="font-display font-bold text-4xl sm:text-5xl tracking-tighter max-w-3xl">Choose your specialization with evidence — not pressure.</h1>
        <p className="mt-5 text-base text-slate2 max-w-3xl">MSIS gives you a calm, structured way to discover which management specialization aligns with your real interests and natural inclinations.</p>
        <div className="mt-10 grid lg:grid-cols-3 gap-px bg-border">
          {[
            ["Clarity", "Stop second-guessing. See your top domains ranked with construct-level explanations."],
            ["Confidence", "Have a meaningful conversation with mentors, faculty, and recruiters with data in hand."],
            ["Calibration", "Pair MSIS results with your academic performance and career goals to make an informed choice."],
          ].map(([t, d]) => (
            <div key={t} className="bg-white p-6">
              <div className="font-display font-bold text-xl">{t}</div>
              <div className="text-sm text-slate2 mt-2">{d}</div>
            </div>
          ))}
        </div>
        <div className="mt-10 flex gap-3 flex-wrap">
          <Link to="/take-test" className="btn-primary" data-testid="fs-take-test">Take the Test</Link>
          <Link to="/sample-report" className="btn-ghost">View Sample Report</Link>
        </div>
      </section>
    </Layout>
  );
}
